import { render, staticRenderFns } from "./warehouseallocationDetails.vue?vue&type=template&id=b814966c&"
import script from "./warehouseallocationDetails.vue?vue&type=script&lang=js&"
export * from "./warehouseallocationDetails.vue?vue&type=script&lang=js&"
import style0 from "./warehouseallocationDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports